// SPDX-FileCopyrightText: 2026 Povl Filip Sonne-Frederiksen
//
// SPDX-License-Identifier: GPL-3.0-or-later

import { authApi } from '../../api/auth';
import type { CaseSummary, GlobalRole } from '../../api/types';
import { useAsync } from '../../app/useAsync';
import { canSeeGroupShares, type Caller } from '../../deling/model';
import { GroupSharesPanel } from './GroupSharesPanel';
import { ShareLinksPanel } from './ShareLinksPanel';

/**
 * Deling — Indstillinger's sharing panels: groups, then share links. Reads the
 * caller's case role once for both. Server mode only; a share-link visitor
 * never gets here with a role that could see either.
 */
export function CaseSharing({ cid, globalRole }: { cid: string; globalRole: GlobalRole }) {
  const info = useAsync<CaseSummary>((s) => authApi.caseInfo(cid, s), [cid]);
  // The Medlemmer panel above already reports a failed or pending case read.
  if (!info.data) return null;
  const caller: Caller = { caseRole: info.data.role, globalRole };
  if (!canSeeGroupShares(caller)) return null;
  return (
    <>
      <GroupSharesPanel cid={cid} caller={caller} />
      <ShareLinksPanel cid={cid} caller={caller} />
    </>
  );
}
